// Builder settings sidebar only (forms.css sets --t-field-inline-label-width there): the label
// column is fixed at 120px for a shared left edge, but a label can fit that box and still read as
// crowded — Button label (101px, Titlecaps icon included) and Event occurrence (102px) already fit
// at 120px, which is exactly why ENG-34476 was filed. This threshold is deliberately smaller than
// the column and picked against the sidebar's real rendered widths, not the column itself.
export const STACK_LABEL_WIDTH_THRESHOLD_PX = 96

export function shouldStackLabel(measuredWidthPx) {
  return measuredWidthPx > STACK_LABEL_WIDTH_THRESHOLD_PX
}
